<template>
  <div class="input-wrapper">
    <div class="input-wrapper__label">{{ label }}</div>
    <div class="input-wrapper__wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputWrapper",
  props: {
    label: {
      type: String,
      default: undefined,
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;

  &__label {
    font-size: px-to-rem(16px);
    color: theme-color("body");
    margin-bottom: spacer("s");
  }

  &__wrapper {
    max-width: 100%;
    position: relative;
    width: 100%;
  }
}
</style>
